// src/components/utils/themeUtils.ts

import { themes } from "../../assets/themeConfig";

export function applyTheme(themeId: string) {
    const theme = themes.find((t) => t.id === themeId);
    if (!theme) return;

    const root = document.documentElement;
    root.style.setProperty("--inner-bg", theme.innerBg);
    root.style.setProperty("--outer-ring-bg", theme.outerRingBg);
    root.style.setProperty("--outer-ring-progress", theme.outerRingProgress);
    root.style.setProperty("--inner-bg-opacity", theme.innerBgOpacity);
    root.style.setProperty("--outer-ring-bg-opacity", theme.outerRingBgOpacity);
    root.style.setProperty("--outer-ring-progress-opacity", theme.outerRingProgressOpacity);
    root.style.setProperty("--pills-bg", theme.pillsBg);
    root.style.setProperty("--timer", theme.timer);
    root.style.setProperty("--current-level-label", theme.currentLevelLabel);
    root.style.setProperty("--current-blinds", theme.currentBlinds);
    root.style.setProperty("--current-ante", theme.currentAnte);
    root.style.setProperty("--next-level-label", theme.nextLevelLabel);
    root.style.setProperty("--next-numbers", theme.nextNumbers);
    root.style.setProperty("--next-ante", theme.nextAnte);
    root.style.setProperty("--text", theme.text);
    root.style.setProperty("--accent", theme.accent);
    root.style.setProperty("--bg-image", `url(${theme.bgImage})`);
    root.style.setProperty("--alternative-logo", `url(${theme.alternativeLogo})`);
}
